import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { api } from "../lib/api";

const fetcher = (url, params) =>
  api.get(url, params ? { params } : undefined).then((response) => response.data);

// Catalog data is safe to serve stale-while-revalidate: returning to a screen
// shows the last data instantly, then refreshes in the background. Prices/stock
// stay correct because the query always revalidates from the server when online.
export function useProducts(params) {
  return useQuery({
    queryKey: ["products", params || {}],
    queryFn: () => fetcher("/products", params),
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
}

export function useCategories() {
  return useQuery({
    queryKey: ["categories"],
    queryFn: () => fetcher("/categories"),
    staleTime: 300_000,
  });
}

export function useBusinessInfo() {
  return useQuery({
    queryKey: ["business-info"],
    queryFn: () => fetcher("/business-info"),
    staleTime: 120_000,
  });
}
